(() => {
  window.addEventListener('load', () => {
    if (window.location.hash){
      let targetElem = document.querySelector(window.location.hash);
      if (targetElem) {
        scrollAdjust(targetElem);
      }
    }
  });

  window.addEventListener('hashchange', (evt) => {
    if (window.location.hash){
      let targetElem = document.querySelector(window.location.hash);
      if (targetElem) {
        scrollAdjust(targetElem)
        return false;
      }
    }
  });

  function scrollAdjust(targetElem) {
    let targetPos = targetElem.getBoundingClientRect().top + window.scrollY;
    let offset = document.querySelector('#header').offsetHeight;
    window.scrollTo(0, Math.max(0, targetPos - offset));
  }
})();